import React from 'react'
import { FaMapMarkerAlt } from 'react-icons/fa'

const delegaciones = [
    {
        nombre: 'Delegación Libertador',
        imagen: './img/libertador.jpeg',
        direccion: 'Avenida Libertad 592',
        mapa: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2170.2992501988097!2d-64.79445911064039!3d-23.818822388089544!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x941ac1973456a499%3A0x860c7b731b422f44!2sAv.%20Libertad%20N%C2%B0%20592%2C%20Y4512%20Libertador%20Gral%20San%20Mart%C3%ADn%2C%20Jujuy!5e0!3m2!1ses!2sar!4v1681793860260!5m2!1ses!2sar'
    },
    {
        nombre: 'Delegación San Pedro',
        imagen: './img/sanpedro.jpeg',
        direccion: 'Sarmiento 80',
        mapa: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1113.3639202266202!2d-64.87067336855678!3d-24.231806958872642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x941a58657dd8d2dd%3A0x6a7af7c39eb9a641!2sSarmiento%2080%2C%20Y4500%20EXB%2C%20Jujuy!5e0!3m2!1ses!2sar!4v1681793388279!5m2!1ses!2sar'
    }
]

const cardStyle = {
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
    background: 'white',
    transition: 'transform 0.25s, box-shadow 0.25s',
}

const InstitucionalDelegaciones = () => {
    return (
        <div className='fondotransparente' style={{ paddingBottom: '3rem' }}>

            <center>
                <h1 className='p-5 botonbordeazul text-white px-5 mx-5 py-3'>Delegaciones del Interior</h1>
            </center>

            <div className='container mt-4'>
                <div className='row g-4 justify-content-center'>
                    {delegaciones.map((d, i) => (
                        <div className='col-lg-6 col-md-10' key={i}>
                            <div
                                style={cardStyle}
                                onMouseEnter={e => {
                                    e.currentTarget.style.transform = 'translateY(-5px)'
                                    e.currentTarget.style.boxShadow = '0 18px 45px rgba(0,0,0,0.18)'
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.transform = 'translateY(0)'
                                    e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)'
                                }}
                            >
                                <div style={{ position: 'relative', height: '320px', overflow: 'hidden' }}>
                                    <img
                                        src={d.imagen}
                                        alt={d.nombre}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                    <div style={{
                                        position: 'absolute', bottom: 0, left: 0, right: 0,
                                        background: 'linear-gradient(to top, rgba(0,0,0,0.65), transparent)',
                                        padding: '2rem 1.25rem 0.85rem',
                                    }}>
                                        <h3 style={{ color: 'white', fontWeight: 700, margin: 0, fontSize: '1.35rem' }}>
                                            {d.nombre}
                                        </h3>
                                    </div>
                                </div>

                                <div style={{ padding: '1.25rem 1.5rem 1.5rem' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1.1rem' }}>
                                        <FaMapMarkerAlt color='#3ba0a8' size={17} />
                                        <span style={{ color: '#575757', fontSize: '0.97rem' }}>{d.direccion}</span>
                                    </div>
                                    <div style={{ borderRadius: '10px', overflow: 'hidden', border: '1px solid #e9ecef' }}>
                                        <iframe
                                            src={d.mapa}
                                            width="100%"
                                            height="240"
                                            style={{ border: 0, display: 'block' }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"
                                            title={d.nombre}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default InstitucionalDelegaciones
